var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOthers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9792 48.9792C58.3403 39.6181 58.3403 24.3819 48.9792 15.0208C39.6181 5.65973 24.3819 5.65973 15.0208 15.0208C5.65973 24.3819 5.65973 39.6181 15.0208 48.9792C24.3819 58.3403 39.6181 58.3403 48.9792 48.9792ZM16.7148 16.7148C25.1457 8.28397 38.8543 8.28397 47.2852 16.7148C55.716 25.1457 55.716 38.8543 47.2852 47.2852C38.8543 55.716 25.1457 55.716 16.7148 47.2852C8.28397 38.8543 8.29376 25.1457 16.7148 16.7148Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9998 40.9888C32.3327 40.9888 32.6265 40.8518 32.8517 40.6363C33.0671 40.4209 33.2042 40.1174 33.2042 39.7844V33.1945H39.7942C40.1271 33.1945 40.4208 33.0574 40.646 32.842C40.8615 32.6265 40.9986 32.323 40.9986 31.9901C40.9986 31.3242 40.46 30.7857 39.8039 30.7955H33.214V24.2055C33.214 23.5396 32.6754 23.0011 32.0194 23.0109C31.3535 23.0109 30.815 23.5494 30.8247 24.2055V30.7955H24.2348C23.5689 30.7955 23.0304 31.334 23.0402 31.9901C23.0402 32.6559 23.5787 33.1945 24.2348 33.1847H30.8247V39.7746C30.7954 40.4503 31.3339 40.9888 31.9998 40.9888Z",
    fill: "#4F0C84"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.7ebbe427aac925d6638b12b610b3f211.svg";
export { ForwardRef as ReactComponent };